import React from 'react';
import './Footer.css';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="footer">
      <div className="footer-inner">

        {/* ── LEFT: BRAND ── */}
        <div className="footer-logo">Du<span>Digital</span></div>

        {/* ── CENTRE: NAV ── */}
        <nav className="footer-nav">
          <a href="#" onClick={(e) => { e.preventDefault(); navigate('/'); }}>Home</a>
          <a href="#" onClick={(e) => { e.preventDefault(); navigate('/about'); }}>About</a>
          <a href="#" onClick={(e) => { e.preventDefault(); navigate('/projects'); }}>Projects</a>
          <a href="#" onClick={(e) => { e.preventDefault(); navigate('/contact'); }}>Contact</a>
          <a href="#" onClick={(e) => { e.preventDefault(); navigate('/apply'); }}>Free Website</a>
        </nav>

        {/* ── RIGHT: EMAIL + SOCIALS ── */}
        <div className="footer-right">
          <a href="mailto:matt@dudigital.ca" className="footer-email">matt@dudigital.ca</a>
          <div className="footer-socials">
            <a href="https://instagram.com/duby" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                <circle cx="12" cy="12" r="4"/>
                <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" stroke="none"/>
              </svg>
            </a>
            <a href="https://facebook.com/duby" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Facebook">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
              </svg>
            </a>
            <a href="https://linkedin.com/in/duby" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="LinkedIn">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
                <rect x="2" y="9" width="4" height="12"/>
                <circle cx="4" cy="4" r="2"/>
              </svg>
            </a>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        <span>© 2026 DuDigital. All rights reserved.</span>
      </div>
    </footer>
  );
};

export default Footer;